import React, { useState,  useEffect } from 'react';
import { Routes, Route, Router, useNavigate } from 'react-router-dom';
import './i18n';  //// import i18n (needs to be bundled ;)) 
import { useTranslation } from 'react-i18next';
import Tabbed from './tabbed';
import ListResorts from './list-ListResorts';
import { use } from 'i18next';

const Pages = {
    HOME: '/',
    RESORTS: '/resorts'
}


const Index = () => {
    const { t } = useTranslation();
    const [searchCriterias, setSearchCriterias] = useState({})
    const navigate = useNavigate();

    const handleLookupResorts = (searchCriterias) => {
        setSearchCriterias(searchCriterias);
        navigate(Pages.RESORTS);
    }

    
    const Home = () => <Tabbed searchCriterias={searchCriterias} onLookup={handleLookupResorts} />;
    const Resorts = () => <ListResorts searchCriterias={searchCriterias} />;

    return (
        <Routes>
            <Route path={Pages.HOME} element={<Home />} />
            <Route path='/home' element={<Home />} />
            <Route path='/index' element={<Home />} />
            <Route path={Pages.RESORTS} element={<Resorts />} />
        </Routes>
    );
};

export default Index;
